import {Component, Input, OnInit} from '@angular/core';
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";

@Component({
    selector: 'app-calendar-wrapper',
    templateUrl: './calendar-wrapper.component.html',
    styleUrls: ['./calendar-wrapper.component.scss'],
})
export class CalendarWrapperComponent implements OnInit {
    @Input()
    sideModel; //list models and set self calendar for each result

    @Input()
    modeleventsType;

    @Input()
    miniCalendar = true;

    @Input()
    avoidSave;
    @Input()
    topPrefix;
    @Input()
    tableData;

    extableData;

    @Input()
    dateFieldType;
    @Input()
    dateFieldData;
    dateFieldDataIndex;

    @Input()
    dateModel;
    @Input()
    dateModelSectionName;

    constructor(public modelProvider: ModelProvider) {
    }

    ngOnInit() {
        this.listSideModel();
    }

    listSideModel() {
        if (this.sideModel) {
            let me = this;
            let filters = {};
            filters['sectionName'] = this.sideModel;
            filters['getEvents'] = true;
            filters[this.sideModel + 'modelOffset'] = 0;
            filters[this.sideModel + 'modelLimit'] = 1000;
            this.modelProvider.list('report', filters)
                .then(function (data: any) {
                    let extableData = data['models'][0].data['finalResReport'];
                    me.tableData[me.sideModel] = extableData[me.sideModel];
                });
        }
    }
}
